import {
    MaterialSamplesContext,
    samplesAPI,
    SavedMaterialSampleSet,
    MaterialSampleSOP,
} from "@/services/samples/samplesAPI";

export async function buildSamplesEditorContext(
    sampleSet: SavedMaterialSampleSet
): Promise<MaterialSamplesContext> {
    const sop = sampleSet.sampleSopID
        ? await samplesAPI.fetchSampleSOPById(sampleSet.sampleSopID!)
        : ({
              name: "Ad-Hoc SOP",
              descriptionUrl: "",
              materialTypeId: sampleSet.materialTypeId,
              sampleDescriptorIds: sampleSet.sampleDescriptorIds,
          } as MaterialSampleSOP);
    const samples = await samplesAPI.fetchSamplesBySetId(sampleSet.id);
    const descriptors = await samplesAPI.fetchSampleDescriptors();
    const materialTypes = await samplesAPI.fetchMaterialTypes();
    // collectionDate comes back as a string, convert it to Date
    samples.forEach((sample) => {
        sample.collectionDate = sample.collectionDate ? new Date(sample.collectionDate) : null;
    });
    return {
        sampleSetId: sampleSet.id,
        sampleSetCode: sampleSet.code,
        experimentCode: sampleSet.experimentCode,
        collectionSOP: sop,
        needByDate: null,
        samples,
        materialType: materialTypes.find((type) => type.id === sampleSet.materialTypeId) || null,
        samplesPerSource: null,
        descriptors: descriptors.filter((descriptor) =>
            sampleSet.sampleDescriptorIds.includes(descriptor.id)
        ),
    } as MaterialSamplesContext;
}
